import React, {useState, useEffect, useRef} from 'react';
import validateRestorePassword from '../utils/validateRestorePassword.js';
import FormText from '../components/FormText.js';
import post from '../utils/post.js';
import {Link} from 'react-router-dom';

export default function Restore() {
	const [checkCode, setcheckCode] = useState(0);
	const [email, setEmail] = useState('');
	const [result, setResult] = useState(0);
	const [loading, setLoading] = useState(false);
	const [password, setPassword] = useState('');
	const [password2, setPassword2] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [passwordError2, setPasswordError2] = useState('');

	const passwordRef = useRef();
	const passwordRef2 = useRef();

	var code = window.location.search.split('=')[1];

	useEffect(() => {
		if (code) {
			getValidRestoreCode();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getValidRestoreCode = () => {
		setLoading(true);

		post('restoreValidCode', {code})
			.then((res) => {
				if (res.data?.result === 1) {
					setcheckCode(1);
					setEmail(res.data?.resultEmail);
				}
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const localError = validateRestorePassword(password, password2);

		setPasswordError(localError.password);
		setPasswordError2(localError.password2);

		if (!localError.password && !localError.password2) {
			setLoading(true);

			post('restore', {email, password, password2})
				.then((res) => {
					if (res.data?.result === 1) {
						setResult(1);
					}
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<div className="login">
			{loading ? <div className="loading" /> : ''}

			<div className="login_shell">
				<div className="login_brand">
					<img className="login_logo" alt="" />
				</div>

				<div className="login_container auth-card auth-card--wide">
					<div className="login_container_in auth-card__body">
						<h1 className="auth-card__title">Obnovení hesla</h1>
						{checkCode === 1 ? (
							<>
								{result === 1 ? (
									<div className="auth-message auth-message--success">Heslo bylo změněno.</div>
								) : (
									<>
										<p className="auth-card__text">Zadej nové heslo pro účet {email}.</p>
										<form method="POST" onSubmit={handleSubmit} className="auth-form">
											<div className="auth-form__field auth-form__field--full">
												<FormText type="password" label="Heslo" value={password} setValue={setPassword} ref={passwordRef} error={passwordError} />
											</div>
											<div className="auth-form__field auth-form__field--full">
												<FormText type="password" label="Znovu hesla" value={password2} setValue={setPassword2} ref={passwordRef2} error={passwordError2} />
											</div>
											<div className="auth-form__actions">
												<input type="submit" name="button_login" value="Odeslat" className="button auth-pill-button" disabled={loading} />
											</div>
										</form>
									</>
								)}
							</>
						) : (
							<div className="auth-message auth-message--danger">Neplatný kód.</div>
						)}

						<div className="auth-links auth-links--center">
							<Link to={'/'} key="lnk_login" className="lnk1 auth-link">
								Zpět na přihlášení
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
